import React from 'react'
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from '@/components/ui/card'
import { useBrandAware } from '@/hooks/useBrandAware'

interface BrandAwareCardProps {
  variant?: 'baby' | 'peach' | 'mint' | 'default'
  children: React.ReactNode
  className?: string
  onClick?: () => void
}

export function BrandAwareCard({ 
  variant = 'default', 
  children, 
  className = '',
  onClick
}: BrandAwareCardProps) {
  const { getBrandProps } = useBrandAware()
  const cardProps = getBrandProps('cards')
  
  const brandVariant = variant === 'default' ? 'brand' : `brand-${variant}` as 'brand' | 'brand-baby' | 'brand-peach' | 'brand-mint'
  
  return (
    <Card 
      {...cardProps} 
      variant={brandVariant}
      className={className}
      onClick={onClick}
    >
      {children}
    </Card>
  )
}

interface BrandAwareCardHeaderProps {
  children: React.ReactNode
  className?: string
}

export function BrandAwareCardHeader({ children, className = '' }: BrandAwareCardHeaderProps) {
  return (
    <CardHeader className={className}>
      {children}
    </CardHeader>
  )
}

interface BrandAwareCardContentProps {
  children: React.ReactNode
  className?: string
}

export function BrandAwareCardContent({ children, className = '' }: BrandAwareCardContentProps) {
  return (
    <CardContent className={className}>
      {children}
    </CardContent>
  )
}

interface BrandAwareCardTitleProps {
  children: React.ReactNode
  className?: string
}

export function BrandAwareCardTitle({ children, className = '' }: BrandAwareCardTitleProps) {
  return (
    <CardTitle className={`text-midnight ${className}`}>
      {children}
    </CardTitle>
  )
}

interface BrandAwareCardDescriptionProps {
  children: React.ReactNode
  className?: string
}

export function BrandAwareCardDescription({ children, className = '' }: BrandAwareCardDescriptionProps) {
  return (
    <CardDescription className={`text-midnight/70 ${className}`}>
      {children}
    </CardDescription>
  )
}

interface BrandAwareCardFooterProps {
  children: React.ReactNode
  className?: string
}

export function BrandAwareCardFooter({ children, className = '' }: BrandAwareCardFooterProps) {
  return (
    <CardFooter className={className}>
      {children}
    </CardFooter>
  )
}